import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const settingService = async (values) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/settings/upsert-setting`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Settings updated successfully";
  }
};
export const getSettingsService = async () => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/settings/get-settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // Return the data containing customers and total count
  } catch (error) {
    console.error("Error fetching report:", error);
    throw error;
  }
};
